const primary = '#4682B4' // rgb(70,130,180)
const blues = {
  blue900: '#0D47A1', // rgb(13, 71, 161)
  blue500: '#2196F3', // rgb(33, 150, 243)
}
const grays = {
  white: '#fff', // rgb(255, 255, 255)
  gray100: '#F2F2F2', // rgb(242, 242, 242)
  gray800: '#5D5D5D', // rgb(93, 93, 93)
  gray900: '#333333', // rgb(51, 51, 51)
  gray950: '#1e1e1e', //rgb(30, 30, 30)
  gray975: '#121212', // rgb(18, 18, 18)
  black: '#000', // rgb(0, 0, 0)
}

export default {
  light: {
    primary,
    text: grays.gray900,
    background: grays.gray100,
    tint: primary,
    tabIconDefault: '#ccc',
    ...blues,
    ...grays,
    completedBackground: primary,
    completedPrimary: grays.white,
    navBarBackground: grays.white,
  },
  dark: {
    primary,
    text: grays.white,
    background: grays.gray900,
    tint: primary,
    tabIconDefault: '#ccc',
    ...blues,
    ...grays,
    white: grays.gray950,
    completedBackground: grays.gray900,
    completedPrimary: blues.blue500,
    navBarBackground: grays.gray975,
  },
}
